import { render } from "./App.vue?vue&type=template&id=cb3e4e88"
const script = {}

import "./App.vue?vue&type=style&index=0&id=cb3e4e88&lang=css"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__